import { Command } from './Command';

export class CheckSubscriptionBySessionIdCommand extends Command {
    constructor(sessionId: string) {
        super()
        this.sessionId = sessionId
    }
    sessionId: string
}